import React from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { history } from '../../../store/configureStore';
import * as appointmentActions from '../../../actions/appointmentActions';
import * as constant from '../../../constants/constant';
// import VideoCall from './App';
import * as url from '../../../tools/config';
import openSocket from 'socket.io-client';
import moment from 'moment';
const socket = openSocket(url.getURLForServer(process.env.REACT_APP_NODE_ENV).SOCKET_URL);
// import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import * as dashboardActions from "../../../actions/dashboardActions";
import $ from "jquery";
class VideoSection extends React.Component {
	constructor(props, context) {
		super(props, context);
		this.state = {
			appointmentDetails: {},
			image: '',
			doctorImage:'',
			DOB: '',
			appointmentMode: '',
      		doctorDetails:{},
	  		emitcall :true,
			docQualification:'',
			docSpecialisation:'',
			docExp:''
		}
		this.onLogoutclick = this.onLogoutclick.bind(this);
		this.searchAppointments = this.searchAppointments.bind(this);
		this.toggle = this.toggle.bind(this)
		this._logout = this._logout.bind(this)
	}
	_logout(event) {
		// debugger;
		let userId = localStorage.getItem('userId')
		this.props.logoutAction.logout({ 'userId': userId })
		event.preventDefault();
		localStorage.clear();
		history.push('/');
	}

	onLogoutclick(data) {
		if (this.state.logoutButton == false) {
			this.setState({
				logoutButton: true
			});
		}
		else {
			this.setState({
				logoutButton: false
			});
		}
	}

	componentWillMount() {
		let videoCall = JSON.parse(localStorage.getItem('videoCall'))

		let appointmentObj = {
			appointmentId: videoCall.appointmentId
    }
    console.log('emit caled ');

		this.props.actions.createSessionIdToken(videoCall, this.props);
		this.props.actions.getAppointmentDetails(appointmentObj, this.props);
    localStorage.setItem('appointmentId',videoCall.appointmentId);

// 		if(localStorage.getItem('userType')== 'specialist'){
// window.open('appointment-consultation/'+videoCall.appointmentId);
// 		}
	}

	componentWillReceiveProps(nextProps) {
console.log("______________&&&&&&&", nextProps)
	this.setState({ appointmentDetails: nextProps.appointmentDetails ? nextProps.appointmentDetails.patient[0] : {},
		docExp:  nextProps.appointmentDetails ? nextProps.appointmentDetails.docExp :'',
		docQualification :  nextProps.appointmentDetails ? nextProps.appointmentDetails.Docqualification :'',
		docSpecialisation :  nextProps.appointmentDetails ? nextProps.appointmentDetails.Docspecialization :'',
		doctorDetails:nextProps.appointmentDetails ?  nextProps.appointmentDetails.users[0]:{},
		image: nextProps.appointmentDetails ? nextProps.appointmentDetails.patientdet[0].profileImage : '',
		doctorImage :  nextProps.appointmentDetails ? nextProps.appointmentDetails.profileImage : '',
		DOB: nextProps.appointmentDetails ? nextProps.appointmentDetails.patientdet[0].dateOfBirth : '',
		appointmentMode: nextProps.appointmentDetails ? nextProps.appointmentDetails.appointmentMode : '', })
		let userData = localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user')) : {};
		if (nextProps.sessionData.sessionConnect) {

			let videoDataObj = {
				receiver_id: nextProps.sessionData.sessionConnect.receiver_id,
				sender_id: nextProps.sessionData.sessionConnect.sender_id,
				userName: userData.userName,
				userType: userData.type,
				videoId: nextProps.sessionData.sessionConnect._id,
				appointmentId: nextProps.sessionData.sessionConnect.appointmentId
      }

      console.log('videoDataObject--------------------',videoDataObj);

      var videodata = JSON.parse(localStorage.getItem('videoDataObj'));
      if((videodata != null ?videodata.receiver_id != videoDataObj.receiver_id : false) || videodata == null){
      if(this.state.emitcall ){
        this.setState({
          emitcall: false
        })


        console.log('emit caled ');
			socket.emit('notify', {
				videoData: videoDataObj,
				notificationType: 'VIDEO_CALL_STARTED'
			}, function () {
        console.log('scoket.emit called*****************************callwaiting  componente');
        alert("here") });

      }
    }
	}
	}
	searchAppointments() {
		let specialistId = localStorage.getItem('userId');
		let appointmentObj = {
			specialistId: specialistId,
			flag: this.state.flag,
			count: this.state.count,
			page: this.state.activePage,
			name: this.state.searchname,
			sortOrder: this.state.sortOrder,
			sorting: this.state.sorting,
			searchdate: this.state.searchdate
		};
		this.props.actions.getAppointments(appointmentObj);
	}
	toggle(e,menuClicked) {
		var windowWidth = $(window).width();
		 if( windowWidth<=768) {
		   if(e == true){
			 $("body").toggleClass("sidebar-open");
		   } else {
			 $("body").toggleClass("sidebar-open");
		   }
		 }

		if( windowWidth >= 768) {
		 if(  e == true ){
		   $("body").toggleClass("sidebar-collapse");
		 } else if (e == false) {
		   $("body").toggleClass("sidebar-collapse");
		 }
		}
	 }
	render() {
		var user = localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user'))  : {};
		let imagePath = '';
		if (user.image == constant.DEFAULT_USER_IMAGE) {
			imagePath = user.gender=='Male'? constant.PRODUCTION_IMAGE_URL + constant.UPLOAD_FOLDER +constant.COMMON_FOLDER +'doctor_m.png': constant.PRODUCTION_IMAGE_URL + constant.UPLOAD_FOLDER +constant.COMMON_FOLDER +'doctor_f.png' ;
		} else {
			imagePath = constant.PRODUCTION_IMAGE_URL + constant.UPLOAD_FOLDER + localStorage.getItem('userId') + '/' + user.image;
		}
		var currentDate = moment(new Date(),'Europe/London')

		let image = this.state.image;
		var userType = localStorage.getItem('userType');

		var defaultImagePath = userType == 'specialist' ?

			this.state.appointmentDetails.gender == 'Male' ? constant.PRODUCTION_IMAGE_URL + "uploads/common/patient_m.png" :
			constant.PRODUCTION_IMAGE_URL + "uploads/common/patient_f.png" :this.state.doctorDetails.gender == "Male" ? constant.PRODUCTION_IMAGE_URL + "uploads/common/doctor_m.png" :
			constant.PRODUCTION_IMAGE_URL + "uploads/common/doctor_f.png";
			var sidebartoggle = true;
			user = JSON.parse(localStorage.getItem('user')) ? JSON.parse(localStorage.getItem('user')): {}
			var condition = (((user.userName != undefined || user.gender != undefined )&& user.availabilityCount > 0 )&& user.isVerified == '2')

		return (
      <div>
      {userType == 'specialist' ?
    	<header className="main-header">
				<Link to={condition ? "/specialist/my-appointment":null} className="logo">						<span className="logo-mini"><img src={require('../../../images/img/logo_er_ms.png')} alt="" /></span>
						<span className="logo-lg"><img src={require('../../../images/img/logo_er.png')} alt="" /></span> </Link>
					<nav className="navbar navbar-static-top" role="navigation">
						<Link href="#" className="sidebar-toggle" data-toggle="push-menu" role="button" onClick={this.toggle}> <img src={require('../../../images/img/menu_list.svg')} alt="" /> <span className="sr-only">Toggle navigation</span> </Link>
						<div className="navbar-custom-menu">
							<ul className="nav navbar-nav">
								<li onClick={this.onLogoutclick} className={this.state.logoutButton == true ? "dropdown user user-menu show" : "dropdown user user-menu"}>

									<Link href="#" className="dropdown-toggle" data-toggle="dropdown">
										<img src={imagePath} className="user-image" alt="User Image" onError={(e) => { e.target.src = defaultImagePath }} />
										<span className="hidden-xs name-capitalize">{user.firstName ? user.firstName : ''} {user.lastName ? user.lastName : ''}</span> </Link>
									<ul className={this.state.logoutButton === true ? "dropdown-menu popupdropdown show" : "dropdown-menu popupdropdown"}>

										<li className="user-setting">	<Link to={{ pathname: "/specialist/my-settings", state: 1 }}>

											<img
												src={require('../../../images/Slicing/Settings-profile.png')}
												className="user-image"
												alt="User Image"
												onError={e => {
													e.target.src = defaultImagePath;
												}}
											/>
											<span>Settings</span>
										</Link></li>
										<li
											className="user-footer passwordLink"
										// style={{ textAlign: "center" }}
										>

											<Link

												className="uploadLink"
												onClick={this._logout}
											>
												<img
													src={require('../../../images/Slicing/logout-profile.png')}
													className="user-image"
													alt="User Image"
													onError={e => {
														e.target.src = defaultImagePath;
													}}
												/>
												<span>	Sign out</span>
											</Link>
										</li>
									</ul>
								</li>
							</ul>
						</div>
					</nav>
        </header>
        :''}
			<div className="content-wrapper">
				<section className="content container-fluid">
					<div className="row">
						<div className="col-md-12">
							<div className="boxMrgB">
								<div className="nav-tabs-custom">
									<ul className="nav nav-tabs">
										<li ><Link href="#tab_1" data-toggle="tab" className="active show">Waiting Room</Link></li>
									</ul>
									<div className="tab-content waitingTap">
										<div className="tab-pane active" id="tab_1">

									<div className={userType == 'specialist' ?"waiting-specialist" : "waiting-patient"}>
											<div className="settingInput settingV">
												<div className="">
												{userType == 'patient' ?	<div className="userProImg">
														{this.state.doctorImage == constant.DEFAULT_USER_IMAGE ? <img className="profile-user-img img-responsive img-circle" src={this.state.doctorDetails.gender == 'Male' ? constant.PRODUCTION_IMAGE_URL + 'uploads/'+ constant.COMMON_FOLDER + 'doctor_m.png':constant.PRODUCTION_IMAGE_URL + 'uploads/'+ constant.COMMON_FOLDER + 'doctor_f.png'} alt="User profile picture" onError={e => {
															e.target.src = defaultImagePath;
														}} /> : <img className="profile-user-img img-responsive img-circle" src={constant.PRODUCTION_IMAGE_URL + constant.UPLOAD_FOLDER +  this.state.doctorDetails._id + '/' + this.state.doctorImage} onError={e => {
															e.target.src = defaultImagePath;
														}} />}
													</div>
													:
														<div className="userProImg">
														{image == constant.DEFAULT_USER_IMAGE ? <img className="profile-user-img img-responsive img-circle" src={this.state.appointmentDetails.gender == "Male"?  constant.PRODUCTION_IMAGE_URL + 'uploads/'+ constant.COMMON_FOLDER + 'patient_m.png':constant.PRODUCTION_IMAGE_URL + 'uploads/'+ constant.COMMON_FOLDER + 'patient_f.png'} alt="User profile picture" onError={e => {
															e.target.src = defaultImagePath;
														}} /> : <img className="profile-user-img img-responsive img-circle" src={constant.PRODUCTION_IMAGE_URL + constant.UPLOAD_FOLDER + this.state.appointmentDetails._id + '/' + image} onError={e => {
															e.target.src = defaultImagePath;
														}} />}

													</div>
												}
												{userType == "specialist" ?
												<div className="  waittingInfo">
														<strong className="capitalize">{this.state.appointmentDetails ? this.state.appointmentDetails.userName : ''}</strong>
														<p>{this.state.DOB ? moment(this.state.DOB).format('DD-MMM-YYYY') : ''}</p>
														<p>{this.state.DOB ? moment().diff(this.state.DOB, 'years') : ''}y/o. {this.state.appointmentDetails ? this.state.appointmentDetails.gender : ''}</p>
														<p>Mode:{this.state.appointmentMode == 2 ? 'Online' : ''}</p>

														<p>Waiting</p>
														<p></p>
												</div>
												:
													<div className="  waittingInfo">
														<strong className="capitalize">Dr. {this.state.doctorDetails ? this.state.doctorDetails.userName : ''}</strong>
														<p>{this.state.doctorDetails && this.state.doctorDetails.gender ? this.state.doctorDetails.gender : ''}</p>
														<p>{this.state.docQualification ? this.state.docQualification : ''} | {this.state.docSpecialisation ? this.state.docSpecialisation : ''}</p>
														<p>Exp: {this.state.docExp ? currentDate.diff(this.state.docExp,'years') + ' Years':"" }  {this.state.docExp ? (currentDate.diff(this.state.docExp,'months') % 12) +' Months' :''}</p>
														<p>Mode:{this.state.appointmentMode == 2 ? 'Online' : ''}</p>

														<p>Waiting</p>
														<p></p>
													</div>
												}
												</div>
											</div>
										</div>

									</div>
								</div>
							</div>
						</div>
					</div></div>
				</section>
				<div className="Copyrightafterlogin">
					<p>Medfix &copy; 2018. All rights reserved</p>

					</div>
			</div>
			</div>
		);
	}
}

//this tells what state should expose on props
function mapStateToProps(state, ownProps) {
	return {
		sessionData: state.appointment.sessionData,
		appointmentDetails: state.appointment.appointmentDetails
	};
}
//this tells what action should expose on props
//bindActionCreators is used to bind all actions at once
function mapDispatchToProps(dispatch) {
	return {
		actions: bindActionCreators(appointmentActions, dispatch),
		logoutAction: bindActionCreators(dashboardActions, dispatch)

	};
}
export default connect(mapStateToProps, mapDispatchToProps)(VideoSection);
